import React from 'react';
import PropTypes from 'prop-types';
import {
  TextField,
} from '@mui/material';
import NumberFormat from 'react-number-format';

import {useTranslation} from 'react-i18next';

export function CutCopyPasteTextField(props) {
  const {t} = useTranslation();
  const [state, setState] = React.useState('');

  const toggleHelperText = () => {
    setState('');
  };

  const handleOnChange = (e) => {
    if(props.onChange){
      props.onChange(e);
    }
    toggleHelperText();
  };
  const handleOnClick = (e) => {
    if(props.onClick){
      props.onClick(e);
    }
    toggleHelperText();
  };
  const handleOnBlur = (e) => {
    if(props.onBlur){
      props.onBlur(e);
    }
    toggleHelperText();
  };
  const handleOnFocus = (e) => {
    if(props.onFocus){
      props.onFocus(e);
    }
    toggleHelperText();
  };
  
  //display error if user tries to cut/copy/paste
  const disableCutCopyPaste = (e, command) => {
    e.preventDefault();
    switch (command) {
      case 'cut':
        setState(t('dialog.labelCut'));
        break;
      case 'copy':
        setState(t('dialog.labelCopy'));
        break;
      case 'paste':
        setState(t('dialog.labelPaste'));
        break;
      default:
        break;
    }
  };
  
  let dynamicProps={}
  if (props.autoComplete==undefined){
    dynamicProps={'autoComplete':"off"}
  }

  return (
    <TextField
      {...props}
      sx={{m: 0}}
      error={Boolean(state) || Boolean(props.error)}
      helperText={state ? state : props.helperText}
      //onCut={(e) => disableCutCopyPaste(e, 'cut')}
      //onCopy={(e) => disableCutCopyPaste(e, 'copy')}
      //onPaste={(e) => disableCutCopyPaste(e, 'paste')}
      onChange={(e) => handleOnChange(e)}
      onClick={(e) => handleOnClick(e)}
      onBlur={(e) => handleOnBlur(e)}
      onFocus={(e) => handleOnFocus(e)}
      {...dynamicProps}
    />
  );
}
CutCopyPasteTextField.propTypes={
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  autoComplete: PropTypes.string
}

export function CutCopyPasteNumberField(props) {
  const {t} = useTranslation();
  const [state, setState] = React.useState('');

  const toggleHelperText = () => {
    setState('');
  };

  const handleOnChange = (e) => {
    if(props.onChange){
      props.onChange(e);
    }
    toggleHelperText();
  };
  const handleOnClick = (e) => {
    if(props.onClick){
      props.onClick(e);
    }
    toggleHelperText();
  };
  const handleOnBlur = (e) => {
    if(props.onBlur){
      props.onBlur(e);
    }
    toggleHelperText();
  };
  const handleOnFocus = (e) => {
    if(props.onFocus){
      props.onFocus(e);
    }
    toggleHelperText();
  };
  
  //display error if user tries to cut/copy/paste
  const disableCutCopyPaste = (e, command) => {
    e.preventDefault();
    switch (command) {
      case 'cut':
        setState(t('dialog.labelCut'));
        break;
      case 'copy':
        setState(t('dialog.labelCopy'));
        break;
      case 'paste':
        setState(t('dialog.labelPaste'));
        break;
      default:
        break;
    }
  };

  let dynamicProps={}
  if (props.autoComplete==undefined){
    dynamicProps={'autoComplete':"off"}
  }

  return (
    <NumberFormat
      {...props}
      error={Boolean(state) || Boolean(props.error)}
      helperText={state ? state : props.helperText}
      onCut={(e) => disableCutCopyPaste(e, 'cut')}
      onCopy={(e) => disableCutCopyPaste(e, 'copy')}
      onPaste={(e) => disableCutCopyPaste(e, 'paste')}
      onChange={(e) => handleOnChange(e)}
      onClick={(e) => handleOnClick(e)}
      onBlur={(e) => handleOnBlur(e)}
      onFocus={(e) => handleOnFocus(e)}
      {...dynamicProps}
    />
  );
}
CutCopyPasteNumberField.propTypes={
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  autoComplete: PropTypes.string
}